import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { BaseErrorInterceptor } from './base-error-interceptor';
import { ToastService } from '@shared/ui/kit/toast/toast.service';
import {
  ErrorInterceptorName,
  ErrorInterceptorNameValue
} from '@shared/interceptors/common/enum/error-interceptor-name';

@Injectable()
export class ErrorBadRequestInterceptor extends BaseErrorInterceptor {
  private readonly toastService: ToastService = inject(ToastService);

  override errorCode: string | null = null;
  override readonly interceptorName: ErrorInterceptorNameValue = ErrorInterceptorName.badRequest;
  override readonly httpStatusCode: HttpStatusCode = HttpStatusCode.BadRequest as const;

  protected handleError(err: HttpErrorResponse): Observable<any> {
    this.toastService.error({
      title: "This didn't go right",
      message: this.getErrorMessageFromHttpErrorResponse(err) ?? 'Error'
    });
    return this.emptyResponse();
  }
}
